







































































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { ICopyLinkedValueBehavior, ICopyLinkedTextsBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { CopyLinkedTextsSelector } from "../selectors";

@Component({
  components: {
    CopyLinkedTextsSelector,
  }
})
export default class CopyLinkedTextsDialog extends Mixins(DialogMixin) {
  items: ICopyLinkedValueBehavior[] = [];
  valueObjects: ICopyLinkedTextsBehaviorSpecifiable[] = [];
  edittingCopyLinkedString: string = "";
  selectedItem: ICopyLinkedValueBehavior = null;
  confirmed: boolean = false;

  itemName: string = "";
  itemNumber: number = 0;

  get hasEdittingCopyLinkedString(): boolean {
    return this.edittingCopyLinkedString !== "";
  }

  get hasSelectedItem(): boolean {
    return !!this.selectedItem;
  }

  get isTopSelectedItem(): boolean {
    return this.hasSelectedItem && this.selectedItem === this.items[0];
  }

  get isBottomSelectedItem(): boolean {
    return this.hasSelectedItem && this.selectedItem === this.items[this.items.length - 1];
  }

  async show(
    items: ICopyLinkedValueBehavior[]): Promise<ICopyLinkedValueBehavior[]> {
    return this.showModal(async () => {
      this.items = ObjectUtility.copyDeeply(items);
      this.edittingCopyLinkedString = "";
      this.selectedItem = null;
      this.itemName = "";
      this.itemNumber = 0;

      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed ? this.items : null;
    });
  }

  addCopyLinkedString() {
    this.items = this.items.concat({
        value: this.edittingCopyLinkedString,
        no: null
        // ダイアログでの表示上はel-colmunのIndexを使用して採番。番号の振り直しは確定時に行う。
    });
  }
  
  updateItem() {
    this.selectedItem.value = this.edittingCopyLinkedString;
  }

  moveItem(offset: number) {
    const index = this.items.indexOf(this.selectedItem);
    const item = this.items[index];
    this.items.splice(index, 1);
    this.items.splice(index + offset, 0, item);
  }

  removeItem() {
    this.items = this.items.filter((v) => v !== this.selectedItem);
  }

  changeItem(value: ICopyLinkedValueBehavior) {
    this.selectedItem = value;
    if (!!value) {
      const item = ObjectUtility.copyDeeply(value) as ICopyLinkedValueBehavior;
      this.itemName = item.value;
      this.itemNumber = item.no;
    }
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
    this.numberingItems();
  }

  cancel(): void {
    this.isVisible = false;
  }

  numberingItems() {
    this.items.forEach((item, index) => item.no = index + 1);
  }
}
